import classNames from 'classnames';
import CountUp from 'react-countup';
import WidgetShell from '../WidgetShell/WidgetShell';
import WidgetLink from '../WidgetLink/WidgetLink';
import { LOG_STATUS_COLORS } from 'constants/dashboard';
import {
  REMINDER_LOG_STATUSES,
  REMINDER_LOG_STATUSES_LABELS,
} from 'constants/reminderLogs';

const LOG_ORDER = [
  REMINDER_LOG_STATUSES.FAILED,
  REMINDER_LOG_STATUSES.EMAIL_FAILED,
  REMINDER_LOG_STATUSES.NOTIFICATION_FAILED,
  REMINDER_LOG_STATUSES.WORKER_FAILED,
  REMINDER_LOG_STATUSES.SUCCESS,
  REMINDER_LOG_STATUSES.SKIPPED,
];

const buildReminderLogLink = (filters = {}) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      params.set(key, value);
    }
  });

  const queryString = params.toString();

  return queryString ? `/reminders/logs?${queryString}` : '/reminders/logs';
};

function LogsSummaryWidget({ data, loading, error, onRetry }) {
  const totals = data?.totals || {};
  const successRate = data?.successRate;
  const deltas = data?.deltaVsPrevious || {};
  const totalLogs = LOG_ORDER.reduce((sum, status) => sum + (totals[status] || 0), 0);
  const hasData = Object.keys(totals).length > 0;

  return (
    <WidgetShell
      title={(
        <WidgetLink
          to={buildReminderLogLink()}
        >
          Reminder Logs
        </WidgetLink>
      )}
      actions={
        !loading && !error && hasData ? (
          <span className="text-3xl font-bold leading-none text-white tabular-nums">
            <CountUp end={totalLogs} duration={1.2} preserveValue />
          </span>
        ) : null
      }
      loading={loading}
      error={error}
      onRetry={onRetry}
      empty={!hasData}
      emptyMessage="No log entries yet"
    >
      <div className="space-y-4">
        {successRate !== null && successRate !== undefined && (
          <div className="flex items-center gap-3 rounded-xl bg-gray-800/50 px-4 py-3">
            <span className="text-sm text-gray-400">Success Rate</span>
            <span className="ml-auto text-2xl font-bold text-emerald-400 tabular-nums">
              <CountUp end={Math.round(successRate * 100)} duration={1} preserveValue />%
            </span>
          </div>
        )}

        <div className="grid grid-cols-2 gap-3">
          {LOG_ORDER.map((status) => {
            const count = totals[status];
            if (count === undefined) return null;
            const colors = LOG_STATUS_COLORS[status] || LOG_STATUS_COLORS.SKIPPED;
            const delta = deltas[status];

            return (
              <div key={status} className={classNames('rounded-xl px-3 py-2.5', colors.bg)}>
                <WidgetLink
                  to={buildReminderLogLink({ status })}
                  className="text-xs"
                >
                  {REMINDER_LOG_STATUSES_LABELS[status]}
                </WidgetLink>
                <div className={classNames('text-xl font-bold tabular-nums', colors.text)}>
                  <CountUp end={count} duration={1} preserveValue />
                </div>
                {delta !== undefined && delta !== null && (
                  <div className="text-xs text-gray-500 mt-0.5">
                    {delta > 0 ? '+' : ''}{Math.round(delta * 100)}% vs prev
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </WidgetShell>
  );
}

export default LogsSummaryWidget;
